module.exports = __webpack_public_path__ + "img/company_4.9e52e790.jpg";